import { render, staticRenderFns } from "./AllHistories.vue?vue&type=template&id=5a224e46&"
import script from "./AllHistories.vue?vue&type=script&lang=js&"
export * from "./AllHistories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports